<template>
    <div class="container is-fluid">
		<div class="notification is-info" v-if="loading==true">
			Loading contacts...

		</div>	
		
		<div class="box" v-if="loading==false && contacts.length > 0">
			<h2 class="title is-size-4">Filters ({{ filteredContacts.length }}) <button class="ml-4 button is-small is-link" @click="resetForm()">Reset Form</button></h2>
			<label class="label">Search</label>
			<div class="control">
				<input class="input" type="text" placeholder="Search contacts..." v-model="searchQuery">
			</div>
			
			<label class="label mt-2">Applied ?</label>
			<div class="control">
				<select class="select input" v-model="appliedFilter">
					<option value="">All</option>
					<option value="1">Yes</option>
					<option value="0">No</option>
				</select>
			</div>
			<label class="label mt-2">Funded ?</label>
			<div class="control">
				<select class="select input" v-model="fundedFilter">
					<option value="">All</option>
					<option value="1">Yes</option>
					<option value="0">No</option>
				</select>
			</div>

		</div>
		
		<div class="box" v-if="loading==false && filteredContacts.length > 0">	
				
				  <table class="table is-fullwidth" id="contacttable">
					  	<thead>
							  <tr>
								<th>Name</th>
								<th>Company</th>
								<th>Email</th>
								<th>Telephone</th>
								<th>Mobile</th>
								
								<th>Applied</th>
								<th>Funded</th>
								  </tr>
							  </thead>
							  <tbody>
								<tr valign="top"  v-for="row in filteredContacts" v-cloak v-bind:key="row.id">
									<td ><router-link :to="{path: '/contacts/' + row.id}" target="_blank">{{row.forename}} {{row.surname}}</router-link></td>
									<td >{{row.company}}</td>
									<td ><a :href="'mailto:' + row.email" target="_blank">{{row.email}}</a></td>
									<td >{{row.telephone}}</td>
									<td >{{row.mobile}}</td>
									
									<td>
										<span v-if="row.applied == 1" class="tag is-success">Yes - {{ row.applied_year }}</span>
										<span v-else-if="row.applied == 0" class="tag is-danger">No</span>
									</td>
									<td>
										<span v-if="row.funded == 1" class="tag is-success">Yes - {{ row.funded_year }}</span>
										<span v-else-if="row.funded == 0" class="tag is-danger">No</span>
									</td>
								</tr>
								  </tbody>
					  </table>


		</div>

		<div class="notification is-warning" v-if="loading==false && filteredContacts.length == 0">
		There are no contacts matching your search criteria
		</div>
		
	</div>

</template>

<script>
import XLSX from 'xlsx';

export default {
 props: ['contacts', 'loading'],
 methods: {
	 exportXLS() {
		 //alert("hi")
		 var wb = XLSX.utils.table_to_book(document.getElementById('contacttable'), {sheet:"Sheet JS"});
		 XLSX.writeFile(wb, 'contacts.xlsx')

	 },

 },
 data() {
    return {
      searchQuery: '',
	  fundedFilter: '',
	  appliedFilter: ''
    }
  },
 computed: {
	filteredContacts() {
		let filtered = this.contacts;
		
		// Apply search filter
		if (this.searchQuery) {
			const query = this.searchQuery.toLowerCase();
			filtered = filtered.filter(contact => 
				contact.forename.toLowerCase().includes(query) ||
				contact.surname.toLowerCase().includes(query) ||
				contact.company.toLowerCase().includes(query) ||
				contact.email.toLowerCase().includes(query) ||
				contact.telephone.toLowerCase().includes(query) ||
				contact.mobile.toLowerCase().includes(query)
			);
		}
		
		// Apply funded filter
		if (this.fundedFilter !== '') {
			filtered = filtered.filter(contact => contact.funded == this.fundedFilter);
		}
		
		// Apply applied filter
		if (this.appliedFilter !== '') {
			filtered = filtered.filter(contact => contact.applied == this.appliedFilter);
		}
		
		return filtered;
	}
 }
 
}
</script>